import FiltersContainerComponent from "./FiltersContainer";

export default FiltersContainerComponent;